import {
  NOTIFICATION_DROPDOWN_REFRESH,
  NOTIFICATION_DROPDOWN_REFRESH_SUCCESS,
  NOTIFICATION_DROPDOWN_REFRESH_ERROR,
} from "./actionTypes"


export const notificationDropdownRefresh = data => ({
  type: NOTIFICATION_DROPDOWN_REFRESH,
  payload: data
});

export const notificationDropdownRefreshSuccess = data => ({
  type: NOTIFICATION_DROPDOWN_REFRESH_SUCCESS,
  payload: {data}
});

export const notificationDropdownRefreshError = error => ({
  type: NOTIFICATION_DROPDOWN_REFRESH_ERROR,
  payload: error,
});
